import Styles from './PostPreviewModal.module.scss'
import { DesignChannel } from 'components/NewFileModal/Types'
import { Button } from 'blaze-ui/Button'
import { Calendar2, Edit3, Send1 } from 'blaze-ui/icons'
import { PostValidations } from './components/PostValidations'
import { useModals } from 'almanac-ui/Modal'
import { InstagramStoryWarning } from './components/InstagramStoryWarning'
import { usePostPreviewContext } from './PostPreviewContext'
import { PostOptionsPage } from './Types'
import { usePublishScheduledPost } from 'hooks/queries/scheduledPosts/usePublishScheduledPost'
import { useState } from 'react'
import { useCompleteDesignAction } from 'components/Design/utils/useCompleteDesignAction'
import { DesignActionType } from 'types'
import { DOC_PATH } from 'paths'
import { DESIGN_PATH } from 'paths'
import { generatePath } from 'react-router-dom'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'

interface Props {
  fileId: string
  channel: DesignChannel
}

export const PostDetailsButtons = ({ fileId, channel }: Props) => {
  const { closeAllModals } = useModals()
  const { scheduledPost, setPage, isPostable } = usePostPreviewContext()
  const [isPosting, setIsPosting] = useState(false)
  const completeActionMutation = useCompleteDesignAction()

  let to = generatePath(DESIGN_PATH, { key: fileId })
  if (scheduledPost?.almanac_file.type === 'article') to = generatePath(DOC_PATH, { slug: fileId })

  const publishScheduledPost = usePublishScheduledPost({
    onSuccess: () => {
      completeActionMutation.mutate({ action: DesignActionType.SchedulePost })
      setIsPosting(false)
      closeAllModals()
    },
    onFailure: () => {
      setIsPosting(false)
    },
  })

  const onSchedulePress = () => {
    setPage(PostOptionsPage.Schedule)
  }

  if (!scheduledPost) return null

  const onPublish = async () => {
    setIsPosting(true)
    publishScheduledPost.mutateAsync({ id: scheduledPost.id })
  }

  return (
    <div className={Styles.postButtons}>
      <PostValidations channel={channel} fileId={fileId} />
      <InstagramStoryWarning scheduledPost={scheduledPost} channel={channel} />
      <Button size="lg" variant="primary" frontIcon={Send1} onPress={onPublish} isDisabled={!isPostable || isPosting}>
        {isPosting ? 'Posting...' : 'Post Now'}
      </Button>
      <Button size="lg" variant="secondary" frontIcon={Calendar2} onPress={onSchedulePress} isDisabled={!isPostable}>
        Schedule for Later
      </Button>
      <ButtonLink to={to} size="lg" variant="tertiary" frontIcon={Edit3}>
        Edit Content
      </ButtonLink>
    </div>
  )
}
